
import { useState } from "react"
import { Button, Col, Container, Form, Row, Tab, Tabs, Card} from "react-bootstrap"
import { useTranslation } from "react-i18next"

export default function RestaurantForm({state, handleInputChange, handleSelectChange, handleImages, imagesAux, handleImage, imageAux, submit, isAddingOrEditing, isSending, disableEnableRestaurants}) {
    const { t } = useTranslation()
    const [activeTab, setActiveTab] = useState("general")

    const handlePlateChange = (index, e) => {
        const { name, value } = e.target
        const updatedPlates = [...state.plates]
        updatedPlates[index] = { ...updatedPlates[index], [name]: value }
        handleInputChange({ target: { name: "plates", value: updatedPlates } })
    }

    const handlePlateImageChange = (index, e) => {
        const file = e.target.files[0]
        const updatedPlates = [...state.plates]
        updatedPlates[index].image = file
        handleInputChange({ target: { name: "plates", value: updatedPlates } })
    }

    const addPlate = () => {
        const updatedPlates = [...state.plates, { title: '', description: '', image: '' }]
        handleInputChange({ target: { name: "plates", value: updatedPlates } })
    }

    const removePlate = (index) => {
        const updatedPlates = state.plates.filter((_, i) => i !== index)
        handleInputChange({ target: { name: "plates", value: updatedPlates } })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        setActiveTab("general");

        submit(e);
    }

    return (
        <Form className="px-4 formulario" onSubmit={handleSubmit}>
            <Row className="text-center mt-3">
                <Col>
                    <h2 className="sd-label text-start">{t('admin.restaurants.namerestaurant')}</h2>
                </Col>
            </Row>
            <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
                <Tab eventKey="general" title={t('admin.restaurants.general')} className="border">
                    <Container >
                        <Row>
                            <Col xs={12} md={4} className="my-3">
                                <h3>{t('admin.restaurants.category')}*</h3>
                                <Form.Select
                                    className="form-control mt-2"
                                    onChange={handleSelectChange}
                                    id="category"
                                    name="category"
                                    value={state?.category}
                                >
                                    <option value="Tradicionalcordobesa" defaultValue>{t('typerestaurant.Tradicionalcordobesa')}</option>
                                    <option value="Obradores">{t('typerestaurant.Obradores')}</option>
                                    <option value="Cafetería">{t('typerestaurant.Cafetería')}</option>
                                    <option value="Brunch">{t('typerestaurant.Brunch')}</option>
                                    <option value="Alimentosmedicinales">{t('typerestaurant.Alimentosmedicinales')}</option>
                                    <option value="Americana">{t('typerestaurant.Americana')}</option>
                                    <option value="Árabe">{t('typerestaurant.Árabe')}</option>
                                    <option value="Argentina">{t('typerestaurant.Argentina')}</option>
                                    <option value="Asador">{t('typerestaurant.Asador')}</option>
                                    <option value="Asiática">{t('typerestaurant.Asiática')}</option>
                                    <option value="Bar">{t('typerestaurant.Bar')}</option>
                                    <option value="Barbacoa">{t('typerestaurant.Barbacoa')}</option>
                                    <option value="Baresparacomer">{t('typerestaurant.Baresparacomer')}</option>
                                    <option value="Británica">{t('typerestaurant.Británica')}</option>
                                    <option value="Café">{t('typerestaurant.Café')}</option>
                                    <option value="Caribeña">{t('typerestaurant.Caribeña')}</option>
                                    <option value="Centroamericana">{t('typerestaurant.Centroamericana')}</option>
                                    <option value="Centroeuropea">{t('typerestaurant.Centroeuropea')}</option>
                                    <option value="Checa">{t('typerestaurant.Checa')}</option>
                                    <option value="China">{t('typerestaurant.China')}</option>
                                    <option value="Colombiana">{t('typerestaurant.Colombiana')}</option>
                                    <option value="Comedor">{t('typerestaurant.Comedor')}</option>
                                    <option value="Comidarápida">{t('typerestaurant.Comidarápida')}</option>
                                    <option value="Cubana">{t('typerestaurant.Cubana')}</option>
                                    <option value="DeCampania">{t('typerestaurant.DeCampania')}</option>
                                    <option value="DeEuropaoriental">{t('typerestaurant.DeEuropaoriental')}</option>
                                    <option value="DelcentrodeItalia">{t('typerestaurant.DelcentrodeItalia')}</option>
                                    <option value="DelsurdeItalia">{t('typerestaurant.DelsurdeItalia')}</option>
                                    <option value="DeOrienteMedio">{t('typerestaurant.DeOrienteMedio')}</option>
                                    <option value="Egipcia">{t('typerestaurant.Egipcia')}</option>
                                    <option value="Española">{t('typerestaurant.Española')}</option>
                                    <option value="Europea">{t('typerestaurant.Europea')}</option>
                                    <option value="Francesa">{t('typerestaurant.Francesa')}</option>
                                    <option value="Fusión">{t('typerestaurant.Fusión')}</option>
                                    <option value="Fusiónjaponesa">{t('typerestaurant.Fusiónjaponesa')}</option>
                                    <option value="Griega">{t('typerestaurant.Griega')}</option>
                                    <option value="Hawaiana">{t('typerestaurant.Hawaiana')}</option>
                                    <option value="Heladeria">{t('typerestaurant.Heladeria')}</option>
                                    <option value="India">{t('typerestaurant.India')}</option>
                                    <option value="Internacional">{t('typerestaurant.Internacional')}</option>
                                    <option value="Irlandesa">{t('typerestaurant.Irlandesa')}</option>
                                    <option value="Italiana">{t('typerestaurant.Italiana')}</option>
                                    <option value="Jamaicana">{t('typerestaurant.Jamaicana')}</option>
                                    <option value="Japonesa">{t('typerestaurant.Japonesa')}</option>
                                    <option value="Latina">{t('typerestaurant.Latina')}</option>
                                    <option value="Libanesa">{t('typerestaurant.Libanesa')}</option>
                                    <option value="Marisco">{t('typerestaurant.Marisco')}</option>
                                    <option value="Marroquí">{t('typerestaurant.Marroquí')}</option>
                                    <option value="Mediterránea">{t('typerestaurant.Mediterránea')}</option>
                                    <option value="Mexicana">{t('typerestaurant.Mexicana')}</option>
                                    <option value="Napolitana">{t('typerestaurant.Napolitana')}</option>
                                    <option value="Pakistaní">{t('typerestaurant.Pakistaní')}</option>
                                    <option value="Peruana">{t('typerestaurant.Peruana')}</option>
                                    <option value="Pizza">{t('typerestaurant.Pizza')}</option>
                                    <option value="Portuguesa">{t('typerestaurant.Portuguesa')}</option>
                                    <option value="Pub">{t('typerestaurant.Pub')}</option>
                                    <option value="Pubconcervezaartesanal">{t('typerestaurant.Pubconcervezaartesanal')}</option>
                                    <option value="Pubrestaurante">{t('typerestaurant.Pubrestaurante')}</option>
                                    <option value="Restaurantedecarne">{t('typerestaurant.Restaurantedecarne')}</option>
                                    <option value="Restaurantesdecerveza">{t('typerestaurant.Restaurantesdecerveza')}</option>
                                    <option value="Saludable">{t('typerestaurant.Saludable')}</option>
                                    <option value="Sichuan">{t('typerestaurant.Sichuan')}</option>
                                    <option value="Siciliana">{t('typerestaurant.Siciliana')}</option>
                                    <option value="Sopas">{t('typerestaurant.Sopas')}</option>
                                    <option value="Streetfood/Comidaenlacalle">{t('typerestaurant.Streetfood/Comidaenlacalle')}</option>
                                    <option value="Sudamericana">{t('typerestaurant.Sudamericana')}</option>
                                    <option value="Sushi">{t('typerestaurant.Sushi')}</option>
                                    <option value="Tailandesa">{t('typerestaurant.Tailandesa')}</option>
                                    <option value="Tiendagourmet">{t('typerestaurant.Tiendagourmet')}</option>
                                    <option value="Toscana">{t('typerestaurant.Toscana')}</option>
                                    <option value="Turca">{t('typerestaurant.Turca')}</option>
                                    <option value="Vasca">{t('typerestaurant.Vasca')}</option>
                                    <option value="Venezolana">{t('typerestaurant.Venezolana')}</option>
                                    <option value="Vinoteca">{t('typerestaurant.Vinoteca')}</option>
                                </Form.Select>
                            </Col>
                            <Col xs={12} md={8} className="my-3">
                                <Form.Control
                                    className="sd-input mt-4"
                                    type='text'
                                    name='name' 
                                    value={state?.name ||  ''}
                                    placeholder={t('admin.restaurants.setname')}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={6} className="my-3">
                                <h3>{t('admin.restaurants.descriptionrestaurant')}*</h3>
                                <Form.Control
                                    as='textarea'
                                    rows={5}
                                    className="sd-input"
                                    type='text'
                                    name='description'
                                    value={state?.description ||  ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Col>
                            <Col xs={12} md={6} className="my-3">
                                <h3>{t('admin.restaurants.descriptionrestaurant')} English</h3>
                                <Form.Control
                                    as='textarea'
                                    rows={5}
                                    className="sd-input"
                                    type='text'
                                    name='descriptionen'
                                    value={state?.descriptionen ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={6} className="my-3">
                                <h3>{t('admin.restaurants.positionxrestaurant')}*</h3>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='positionx'
                                    value={state?.positionx ||  ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Col>
                            <Col xs={12} md={6} className="my-3">
                                <h3>{t('admin.restaurants.positionyrestaurant')}*</h3>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='positiony'
                                    value={state?.positiony ||  ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={8} className="my-3">
                                <h3>{t('admin.restaurants.addressrestaurant')}*</h3>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='address'
                                    value={state?.address || ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Col>
                            <Col xs={12} md={4} className="my-3">
                                <h3>{t('admin.restaurants.phonerestaurant')}*</h3>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='phone'
                                    value={state?.phone || ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={6} className="my-3">
                                <h3>{t('admin.restaurants.webrestaurant')}</h3>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='web'
                                    value={state?.web || ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                            <Col xs={12} md={6} className="my-3">
                                <h3>{t('admin.restaurants.deliveryUrlRestaurant')}</h3>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='deliveryUrl'
                                    value={state?.deliveryUrl ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={4} className="my-3">
                                <h3>{t('admin.restaurants.facebookrestaurant')}</h3>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='facebook'
                                    value={state?.facebook ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                            <Col xs={12} md={4} className="my-3">
                                <h3>{t('admin.restaurants.xrestaurant')}</h3>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='x'
                                    value={state?.x ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                            <Col xs={12} md={4} className="my-3">
                                <h3>{t('admin.restaurants.instagramrestaurant')}</h3>
                                <Form.Control
                                    className="sd-input"
                                    type='text'
                                    name='instagram'
                                    value={state?.instagram ||  ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={4} className="my-3">
                                <h3>{t('admin.restaurants.setimage')}</h3>
                                <Form.Control
                                    className="sd-input"
                                    type='file'
                                    name='image'
                                    onChange={handleImage}
                                />
                                <div className='text-center my-3'>
                                {imageAux
                                    ?
                                        <img className="img-logo" alt="Preview" src={typeof imageAux === 'string' ? imageAux : URL.createObjectURL(imageAux)} />
                                    :
                                        state?.image
                                            ?
                                                <img className="img-logo" alt="Preview" src={typeof state?.image === 'string' ? state?.image : URL.createObjectURL(state?.image)} />
                                            :
                                                <div className="img-logo"></div>
                                }
                                </div>
                            </Col>
                            <Col xs={12} md={8} className="my-3">
                                <h3>{t('admin.restaurants.setimages')}</h3>
                                <Form.Control
                                    className="sd-input"
                                    type="file"
                                    multiple
                                    onChange={handleImages}
                                />
                                <div className='miniaturas'>
                                {imagesAux && imagesAux?.length > 0
                                        ?
                                            imagesAux?.map((image, index) => (
                                                <img key={index} className="img-logo miniatura my-1" alt="Preview" src={typeof image === 'string' ? image : URL.createObjectURL(image)} />
                                            ))
                                        :
                                            state?.images && state?.images?.length > 0
                                                ?
                                                    state?.images?.map((image, index) => (
                                                        <img key={index} className="img-logo miniatura my-1" alt="Preview" src={typeof image === 'string' ? image : URL.createObjectURL(image)} />
                                                    ))
                                                :
                                                null
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Tab>
                <Tab eventKey="plates" title={t('admin.restaurants.plates')}>
                    <Container>
                        <Row>
                            <Col className="my-3">
                                <h3>{t('admin.restaurants.plates')}</h3>
                                <div className="d-flex justify-content-end">
                                    <Button variant='primary' type="button" className="btn-primary my-2 px-3" onClick={addPlate}>
                                        <i className="fas fa-plus me-2"></i> {t('admin.restaurants.addplate')}
                                    </Button>
                                </div>
                                {state?.plates?.length > 0 && (
                                    <div className="my-3">
                                        {state?.plates?.map((plate, index) => (
                                            <Card key={index} className="my-3">
                                                <Card.Body>
                                                    <Row className="align-items-center">
                                                        <Col xs={12} md={10}>
                                                            <Row className="my-3 align-items-center">
                                                                <Col xs={12} md={4}>
                                                                    <Form.Control
                                                                        className="sd-input"
                                                                        type='text'
                                                                        name='title'
                                                                        value={plate.title || ''}
                                                                        onChange={(e) => handlePlateChange(index, e)}
                                                                        placeholder={t('admin.restaurants.titleplate')}
                                                                        required
                                                                    />
                                                                </Col>
                                                                <Col xs={12} md={6}>
                                                                    <Form.Control
                                                                        className="sd-input mt-5"
                                                                        type='file'
                                                                        onChange={(e) => handlePlateImageChange(index, e)}
                                                                    />
                                                                    <div className='text-center my-3'>
                                                                        {plate.image && (
                                                                            <img className="img-logo" alt="Preview" src={typeof plate.image === 'string' ? plate.image : URL.createObjectURL(plate.image)} />
                                                                        )}
                                                                    </div>

                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xs={12} md={6}>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        className="sd-input"
                                                                        name='description'
                                                                        rows={5}
                                                                        value={plate.description || ''}
                                                                        onChange={(e) => handlePlateChange(index, e)}
                                                                        placeholder={t('admin.restaurants.descriptionplate')}
                                                                        required
                                                                    />
                                                                </Col>
                                                                <Col xs={12} md={6}>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        className="sd-input"
                                                                        name='descriptionen'
                                                                        rows={5}
                                                                        value={plate.descriptionen || ''}
                                                                        onChange={(e) => handlePlateChange(index, e)}
                                                                        placeholder={t('admin.restaurants.descriptionplate')}
                                                                        required
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={12} md={2}>
                                                            <Button variant='danger' type="button" className="btn-danger w-100 my-2" onClick={() => removePlate(index)}>
                                                                <i className="fas fa-trash me-2"></i>
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        ))}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </Tab>
            </Tabs>
            <Row>
                <Col className="my-3 d-flex justify-content-end">
                    {isAddingOrEditing === 'editing' && (
                        <Button type="button" className="btn-fourth px-5 me-3" onClick={(e) => disableEnableRestaurants(e)}>
                            <label className='label-button'>{state?.active ? t('admin.restaurants.disable') : t('admin.restaurants.enable')}</label>
                        </Button>
                    )}
                     <Button variant='primary' type="submit" className="btn-primary px-5">
                    {isSending
                        ?
                            <>
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </>
                        :
                            isAddingOrEditing === 'editing'
                            ?
                                <>{t('admin.restaurants.update')}</>
                            :
                                <>{t('admin.restaurants.register')}</>
                    }
                    </Button>
                </Col>
            </Row>
        </Form>
    )
}